import { Milestone, Progress, Stage } from "../../interfaces/progress";
import {
    MILESTONES_FETCH_PROGRESS,
    MILESTONES_RESET_PROGRESS,
    MILESTONES_SET_INSTANCE_NAME,
    MILESTONES_SET_INTERACIONES
} from "../types/milestonesTypes";

type ActionsI =
    | { type: typeof MILESTONES_FETCH_PROGRESS, payload: any }
    | { type: typeof MILESTONES_SET_INSTANCE_NAME, payload: string }
    | { type: typeof MILESTONES_SET_INTERACIONES, payload: any }
    | { type: typeof MILESTONES_RESET_PROGRESS }

interface StateI {
    report_type: string;
    progress: Progress[];
    stage: Stage;
    instance_name: string;
    interactions?: number[];
    alert_url?: string;
    alerts?: Milestone[]
}

const initialState: StateI = {
    report_type: "",
    progress: [],
    stage: {
        name: "",
        description: "",
        image_url: ""
    },
    instance_name: "",
    interactions: [],
    alerts: [],
    alert_url: ""
};

export const milestonesReducer = (state = initialState , action:ActionsI): StateI => {

    switch(action.type){

        case MILESTONES_FETCH_PROGRESS:
            return {...state,
                ...action.payload
            };

        case MILESTONES_RESET_PROGRESS:
            return initialState

        case MILESTONES_SET_INSTANCE_NAME:
            return {...state, instance_name: action.payload}

        case MILESTONES_SET_INTERACIONES:
            return {...state, interactions: action.payload}

        default:
            return state;
    }


}
